import * as React from "react"
import { Fragment } from "react"

export const { Provider, Consumer } = React.createContext()

let update = 0

const log = (...props) => {
    // console.log(...props)
    return true
}

export class DragDropContext extends React.Component {
    state = {
        isActive: this.props.isActive,
        draggingOverItem: null,
        draggingElm: null,
        dragPayload: null,
        dropPayload: null,
        update: 0,
        isOver: elm => this.state.draggingOverItem === elm,
        isDragging: elm => this.state.draggingElm === elm,
        onDragOver: (draggingOverItem, position, dropPayload) =>
            (this.state.draggingOverItem !== draggingOverItem ||
                position !== this.state.position) &&
            log(
                "onDragOver",
                {
                    from: this.state.draggingOverItem,
                    to: draggingOverItem,
                },
                position,
                this.state.position
            ) &&
            this.setState({ draggingOverItem, position, dropPayload }, () => {
                log(
                    "onDragOverFinished",
                    {
                        from: this.state.draggingOverItem,
                        to: draggingOverItem,
                    },
                    position,
                    this.state.position
                )
            }),
        onDragLeave: leavingElm =>
            this.state.draggingOverItem === leavingElm &&
            log("dragLeave") &&
            false &&
            this.setState({ draggingOverItem: null }),
        startDrag: (elm, dragPayload) => {
            log("start context", elm)
            this.setState({ draggingElm: elm, dragPayload, update: update++ })
        },
        stopDrag: (elm, dragPayload) => {
            log("stop context")
            this.setState({ draggingElm: null, draggingOverItem: null })
        },
        onDrop: elm => {
            this.setState({ draggingElm: null, draggingOverItem: null })
            this.props.onDrop({
                dragPayload: this.state.dragPayload,
                position: this.state.position,
                dropPayload: this.state.dropPayload,
            })
        },
        debug: "",
    }

    getStateAndProps() {
        return {
            isDragging: !!this.state.draggingElm,
            hasDropTarget: !!this.draggingOverItem,
            dragPayload: this.state.dragPayload,
            dropPayload: this.state.dropPayload,
        }
    }
    componentWillReceiveProps({ isActive }) {
        if (isActive !== this.state.isActive) {
            this.setState({
                isActive,
            })
        }
    }
    render() {
        // log("DragDropContext.render")
        return (
            <Provider value={this.state}>
                <Fragment>
                    {this.props.debug && (
                        <div className="display-flex flex-column flex-1">
                            updates: {this.state.update}
                            <br />
                            <span>
                                isDragging?{" "}
                                {this.state.draggingElm
                                    ? JSON.stringify(this.state.dragPayload)
                                    : "nope"}
                                <br />
                                {this.state.draggingOverItem
                                    ? JSON.stringify(this.state.dropPayload)
                                    : "no drop"}
                            </span>
                        </div>
                    )}

                    {this.props.children(this.getStateAndProps())}
                </Fragment>
            </Provider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/editor/dnd/Context.js